/**
 * モーダル 
 */

export default function initModal() {
  modal();
}

import MicroModal from "micromodal";

function modal() {  
  MicroModal.init({
    disableScroll: true,
  });

  //SP時のバグ修正（DOMの位置変更）
  const modals = document.querySelectorAll('.acf-img-popup-modal');
  modals.forEach(modal => {
    if (modal && modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
  });
}
